export default __webpack_public_path__ + "c6ba2406f26b73ec249fd4153b76983a.png";